module.exports = __webpack_public_path__ + "static/media/venmo_pay.f3d469a2.svg";